/* tslint:disable */
/* eslint-disable */
/**
 * MyAzimut
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as anagrafica from './anagrafica';
import * as anagraficaCF from './anagrafica-cf';
import * as papyrusMetadata from './papyrus-metadata';
import * as papyrusStrem from './papyrus-stream';
import * as signroom from './signroom-orchestrator';
import * as openId from './pc-openid';
import * as dob from './dob';
import * as documentale from './documentale';
import * as prometeia from './prometeia';
import * as objectway from './objectway-zenith';
export * from "./apc/api";
export * from "./apc/configuration";


const externalApi = { papyrusMetadata, papyrusStrem, anagrafica, dob, documentale, prometeia, signroom, anagraficaCF, openId, objectway };
export default externalApi;
